<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="启用状态">
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="请选择启用状态"
                dictCode="obj_status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="产品名称">
              <a-input
                v-model="queryParam.productName"
                placeholder="请输入产品名称"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        :columns="columns"
        size="middle"
        :dataSource="dataSource"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        rowKey="id"
        :scroll="{ x: 1500 }"
        ref="table"
        bordered
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm
                  title="确定删除吗?"
                  @confirm="() => handleDelete(record.id)"
                >
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <!-- 字符串超长截取省略号显示-->
        <span slot="content" slot-scope="text">
          <j-ellipsis :value="text" />
        </span>
      </a-table>
    </div>

    <product-manage-modal
      ref="modalForm"
      :dataSource="dataSource"
      @ok="modalFormOk"
    ></product-manage-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import ProductManageModal from './modules/ProductManageModal';

export default {
  name: 'ProductManage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    ProductManageModal
  },
  data() {
    return {
      description: '产品管理页面',
      queryParam: {},
      // 表头
      columns: [
        {
          title: '产品代码',
          align: 'center',
          dataIndex: 'productCode'
        },
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'productName',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 12
              ? text.substr(0, 12) + '...'
              : text;
          }
        },
        {
          title: '收益区间类型',
          align: 'center',
          dataIndex: 'incomeRangeType_dictText'
        },
        {
          title: '收益率',
          align: 'center',
          dataIndex: 'yield'
        },
        {
          title: '按钮文案',
          align: 'center',
          dataIndex: 'buttonCopy'
        },
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'status_dictText'
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          height: 50,
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/product/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/product/delete',
        deleteBatch: process.env.VUE_APP_CMS_MARKETING + '/product/deleteBatch'
      },
      dictOptions: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    loadData2() {
      this.dataSource = [];
      getAction(this.url.list, this.queryParam).then(res => {
        if (res.success) {
          this.dataSource = res.result.records;
          console.log('dataSource', this.dataSource);
        }
      });
    }
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
